import { Link } from "react-router-dom";
import type { EventItem } from "@/types/content";
import { categories } from "@/mocks/events";
import { formatCount, formatDate } from "@/utils/format";

export default function EventSidebar({ event }: { event: EventItem }) {
  const meta = [
    { icon: "ri-fire-line", label: "围观热度", value: formatCount(event.heat) },
    { icon: "ri-chat-3-line", label: "评论数量", value: `${formatCount(event.commentCount)} 条` },
    { icon: "ri-time-line", label: "阅读时长", value: event.readTime },
    { icon: "ri-calendar-line", label: "更新时间", value: formatDate(event.publishedAt) },
  ];

  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-24">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">事件速览</h2>
        <dl className="mt-4 flex flex-col gap-3.5">
          {meta.map((m) => (
            <div key={m.label} className="flex items-center justify-between text-sm">
              <dt className="flex items-center gap-2 text-foreground-600">
                <i className={`${m.icon} text-base text-secondary-600`}></i>
                {m.label}
              </dt>
              <dd className="font-semibold text-foreground-950">{m.value}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-4 flex items-center gap-2 border-t border-background-200 pt-4 text-xs text-foreground-500">
          <i className="ri-user-star-line text-sm"></i>
          内容整理：{event.author}
        </p>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">瓜田标签</h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {event.tags.map((tag) => (
            <Link
              key={tag}
              to={`/events?q=${encodeURIComponent(tag)}`}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900 transition-colors hover:bg-accent-200"
            >
              <i className="ri-price-tag-3-line text-sm"></i>
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">换片瓜田逛逛</h2>
        <ul className="mt-4 flex flex-col gap-1">
          {categories
            .filter((c) => c.key !== "all")
            .map((c) => (
              <li key={c.key}>
                <Link
                  to={`/events?cat=${c.key}`}
                  className={`flex items-center justify-between rounded-md px-3 py-2.5 text-sm transition-colors ${
                    c.key === event.category
                      ? "bg-primary-100 font-semibold text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <i className={`${c.icon} text-base`}></i>
                    {c.name}
                  </span>
                  <i className="ri-arrow-right-s-line text-base text-foreground-400"></i>
                </Link>
              </li>
            ))}
        </ul>
      </div>
    </aside>
  );
}